module.exports = __webpack_public_path__ + "img/6.2f463c7a.jpg";